'use client';

import * as React from 'react';
import { ModalDetails } from './modal-details';
import { useDashboardStore } from '../../store/dashboard-store';
import { generateCourseColorScheme } from '../../utils/colors';
import { EventBus } from '@/shared/utils';
import { DashboardEvents } from '../../events';

interface DashboardModalProps {
  eventBus: EventBus<DashboardEvents>;
}
export const DashboardModal: React.FC<DashboardModalProps> = ({ eventBus }) => {
  const dashboardModal = useDashboardStore((state) => state.dashboardModal);
  const setDashboardModal = useDashboardStore((state) => state.setDashboardModal);

  const closeModal = () => setDashboardModal(null);

  if (!dashboardModal || !dashboardModal.data) {
    return null;
  }

  const colorScheme = generateCourseColorScheme(
    dashboardModal?.data?.highlighted,
    dashboardModal?.data?.courseType,
  );

  return (
    <ModalDetails
      trailerUrl=""
      eventBus={eventBus}
      {...dashboardModal.data}
      documentId={dashboardModal.data?.documentId}
      colorScheme={colorScheme}
      dialogIsOpen={true}
      dialogToggle={closeModal}
    />
  );
};
